import React, { useEffect, useState } from 'react';
import { Text, Card, Button, Checkbox } from '@smarterservices/smarter-ui';
import { ParamsNotFoundError } from '../../../helpers/definedErrors';

import { sendMessageToExtension } from '../../../helpers/helpers';
const Acknowledgement = () => {
  const [bodyText, setBodyText] = useState(null);
  const [checkboxText, setCheckboxText] = useState(null);
  const [iframeId, setIframeId] = useState(null);
  const [acknowledgementName, setAcknowledgementName] = useState(null);
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  useEffect(() => {
    const url = new URL(window.location.href);
    const acknowledgementParams = new Proxy(new URLSearchParams(url.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (
      !acknowledgementParams ||
      !acknowledgementParams.bodyText ||
      !acknowledgementParams.iframeId ||
      !acknowledgementParams.checkboxText
    ) {
      throw new ParamsNotFoundError();
    }

    setBodyText(acknowledgementParams.bodyText);
    setCheckboxText(acknowledgementParams.checkboxText);
    setIframeId(acknowledgementParams.iframeId);
    setAcknowledgementName(acknowledgementParams.acknowledgementName);
  }, []);

  async function sendAcknowledgement() {
    const response = await sendMessageToExtension({
      message: 'sp_background__sendAcknowledgement',
      iframeId,
      acknowledgement: {
        name: acknowledgementName,
        body: bodyText,
        label: checkboxText,
      },
    });

    if (!response) {
      console.log('No response from sendAcknowledgement function.');
    }
  }
  return (
    <Card
      background="secondary"
      borderColor="brand"
      borderWidth="large"
      borderRadius="x-small"
    >
      <Card.Header background="brand">
        <Card.Title>Acknowledgement</Card.Title>
      </Card.Header>
      <Card.Body padding="0" height="100%">
        <div
          style={{
            position: 'relative',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          {/* Scrollable text area */}
          <div
            style={{
              width: '100%',
              maxHeight: 'calc(100% - 100px)',
              padding: '48px 32px',
              overflow: 'auto',
              textAlign: 'center',
            }}
          >
            <Text size="medium" align="center">
              {bodyText}
            </Text>
          </div>

          {/* Fixed button container */}
          <div
            style={{
              position: 'absolute',
              bottom: '0',
              left: '0',
              right: '0',
              height: '100px',
              padding: '0px 32px',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'start',
            }}
          >
            <Checkbox
              label={checkboxText}
              onChange={(e) => setIsAcknowledged(e.target.checked)}
            />
            <Button
              color="primary"
              onClick={sendAcknowledgement}
              interaction={isAcknowledged ? 'enabled' : 'disabled'}
            >
              Accept
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Acknowledgement;
